import { render, staticRenderFns } from "./SearchCategoryGoods.vue?vue&type=template&id=34f49d77&scoped=true"
import script from "./SearchCategoryGoods.vue?vue&type=script&lang=ts"
export * from "./SearchCategoryGoods.vue?vue&type=script&lang=ts"
import style0 from "./SearchCategoryGoods.vue?vue&type=style&index=0&id=34f49d77&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f49d77",
  null
  
)

export default component.exports